import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProfilePage } from "./ui";

export function ProfilePageRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.profile(),
    element: createElement(ProfilePage),
    children: rest,
  };
}
